(() => {
  const excludedSections = new Set(['BF Hero', 'BF Anchor Nav', 'BF Power Levels']);
  const cardSelector = [
    '.bf26-vault-cell',
    '.bf26-cvault-cell',
    '.bf26-draw-week',
    '.bf26-gift-card',
    '.bf26-points-stage',
    '.bf26-package__panel'
  ].join(',');
  const immediateVaultCardSelector = '.bf26-vault-cell,.bf26-cvault-cell';
  const contentSelector = [
    'h1',
    'h2',
    'h3',
    'p',
    'button',
    'a',
    '.bf26-countdown__stage',
    '.bf26-draw-section__hero-media',
    '.bf26-draw-section__timeline-picture',
    '.bf26-gifts__intro',
    '.bf26-points-section__card',
    '.bf26-side-quest__picture'
  ].join(',');

  const start = () => {
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const targets = [];

    document.querySelectorAll('[data-bf-section]').forEach((section) => {
      if (excludedSections.has(section.dataset.bfSection)) return;
      if (section.dataset.bfSection === 'BF Package Builder') return;

      let sequence = 0;
      section.querySelectorAll(`${cardSelector},${contentSelector}`).forEach((element) => {
        const owningCard = element.closest(cardSelector);
        if ((owningCard && owningCard !== element) || (!owningCard && element.querySelector(cardSelector))) return;
        if (!element.matches(cardSelector) && (element.closest('[hidden]') || getComputedStyle(element).display === 'none')) return;
        const immediate = element.matches(immediateVaultCardSelector);
        element.classList.add('bf26-first-enter');
        if (immediate) element.classList.add('bf26-vault-card-enter');
        element.style.setProperty('--bf26-enter-delay', immediate ? '0ms' : `${Math.min(sequence, 7) * 70}ms`);
        if (!immediate) sequence += 1;
        targets.push(element);
      });
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-visible', 'is-entered'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const target = entry.target;
          target.classList.add('is-visible');
          observer.unobserve(target);
          const finish = () => target.classList.add('is-entered');
          target.addEventListener('transitionend', finish, { once: true });
          setTimeout(finish, 1300);
        });
      },
      { threshold: 0.01, rootMargin: '0px' }
    );

    targets.forEach((target) => observer.observe(target));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
